import React, { useState } from 'react'
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import SearchIcon from '@material-ui/icons/Search'
import axios from 'axios'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { buscarEndereco } from 'actions/mapaActions'

const useStyles = makeStyles((theme) =>
  createStyles({
    barra: {
      flex: 1,
    },
    root: {
      padding: '8px 4px',
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    alert: {
      marginBottom: theme.spacing(2),
    },
  })
)

async function obterEndereco(e) {
  const response = await axios.get(
    `https://nominatim.openstreetmap.org/search/${e}?format=json&addressdetails=1&polygon_svg=1&bounded=1&viewbox=-50.306,-9.113,-33.058,0.286`
  )

  return response.data
}

export const BarraDePesquisaMapa = () => {
  const classes = useStyles()
  const [endereco, setEndereco] = useState('')
  const [tituloDialog, setTituloDialog] = useState('')
  const [textoDialog, setTextoDialog] = useState('')
  const [dadosMapa, setDadosMapa] = useState('')
  const [openDialog, setOpenDialog] = React.useState(false)

  const dispatch = useDispatch()

  function alterarEndereco() {
    const resultado = obterEndereco(endereco)
    resultado.then(function e(dados) {
      const enderecoResult = dados[0]
      if (enderecoResult) {
        setTituloDialog('Deseja alterar o endereço?')
        setTextoDialog(enderecoResult.display_name)
        setOpenDialog(true)
        setDadosMapa([enderecoResult])
      }
    })
  }

  const submit = (evt) => {
    evt.preventDefault()
    alterarEndereco()
  }

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const handleCloseAlterarEndereco = () => {
    setOpenDialog(false)
    dispatch(buscarEndereco(dadosMapa))
  }
  const handleCloseSemAlterarEndereco = () => {
    setOpenDialog(false)
  }

  return (
    <div className={classes.barra}>
      <Paper component="form" className={classes.root}>
        <InputBase
          className={classes.input}
          placeholder="Digite o endereço ou as coordenadas no seguinte formato: 99.9999, 99.9999"
          inputProps={{ 'aria-label': 'search google maps' }}
          value={endereco}
          onChange={(e) => setEndereco(e.target.value)}
          label="CEP"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Divider className={classes.divider} orientation="vertical" />
        <Button
          onClick={submit}
          className={classes.iconButton}
          aria-label="search"
          color="primary"
          variant="contained"
        >
          <SearchIcon />
          Buscar
        </Button>
      </Paper>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleCloseAlterarEndereco}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{tituloDialog}</DialogTitle>
        <DialogContent>
          <DialogContentText>{textoDialog}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseSemAlterarEndereco} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleCloseAlterarEndereco}
            variant="contained"
            color="primary"
            autoFocus
          >
            Aceitar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
